'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var growthbookReact = require('@growthbook/growthbook-react');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var index = require('./index.js');
var useTitanAnalytics = require('./useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function growthbookAttributes({
  carrier,
  localeCountry,
  localeLanguage,
  orderNumbers,
  retailerMoniker,
  trackingNumbers,
  deviceType
}) {
  const trackingNumber = trackingNumbers?.[0] ?? 'undefined';
  return {
    track_retailerMoniker: retailerMoniker,
    track_trackingNumber: trackingNumber,
    track_orderNumber: orderNumbers?.[0] ? `o-${retailerMoniker}-${orderNumbers[0]}` : `t-${carrier ?? 'undefined'}-${trackingNumber}`,
    track_localeCountry: localeCountry,
    track_localeLanguage: localeLanguage,
    track_deviceLayout: deviceType ?? ''
  };
}
const NarvarGrowthBookProvider = ({
  growthbookOptions,
  deviceType,
  children
}) => {
  // create a growthbook client when options are specified by the server
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const logEventRef = React.useRef(logEvent);
  logEventRef.current = logEvent;
  const titanAnalytics = useTitanAnalytics["default"]();
  const titanAnalyticsRef = React.useRef(titanAnalytics);

  // keep growthbook attributes in sync
  const {
    state: pageContext
  } = index.usePageContext();
  const gbAttributes = growthbookAttributes({
    ...pageContext,
    deviceType
  });
  const growthbook = React.useMemo(() => new growthbookReact.GrowthBook({
    ...growthbookOptions,
    trackingCallback: (experiment, result) => {
      logEventRef.current({
        eventType: nthHookContextAnalytics.NarvarEventTypes.EXPERIMENT,
        config: [{
          name: 'experimentName',
          options: [experiment.key]
        }, {
          name: 'choice',
          options: [result.value]
        }]
      });
      titanAnalyticsRef.current?.track({
        event: 'experiment_viewed',
        channel: 'web',
        type: 'track',
        context: {},
        properties: {
          experimentId: experiment.key,
          variationId: result.variationId.toString(),
          narvar_product_context: 'track',
          extra_properties: [{
            key: 'track_orderNumber',
            value: gbAttributes?.track_orderNumber
          }, {
            key: 'track_retailerMoniker',
            value: gbAttributes?.track_retailerMoniker
          }, {
            key: 'track_trackingNumber',
            value: gbAttributes?.track_trackingNumber
          }, {
            key: 'track_deviceLayout',
            value: gbAttributes?.track_deviceLayout
          }, {
            key: 'track_localeLanguage',
            value: gbAttributes?.track_localeLanguage
          }, {
            key: 'track_localeCountry',
            value: gbAttributes?.track_localeCountry
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    },
    onFeatureUsage: (featureKey, result) => {
      logEventRef.current({
        eventType: nthHookContextAnalytics.NarvarEventTypes.FEATURE_USAGE,
        config: [{
          name: 'featureName',
          options: [featureKey]
        }, {
          name: 'value',
          options: [result.value]
        }]
      });
    }
  }), [growthbookOptions, gbAttributes]);

  // configure growthbook to autorefresh features when attributes change
  React.useEffect(() => {
    growthbook?.loadFeatures({
      autoRefresh: true
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error('growthbook.loadFeatures threw', err);
    });
  }, [growthbook]);
  React.useEffect(() => {
    growthbook?.setAttributes(gbAttributes).catch(err => {
      // eslint-disable-next-line no-console
      console.error('growthbook.setAttributes threw', err);
    });
  }, [growthbook, gbAttributes]);
  return /*#__PURE__*/React__default["default"].createElement(growthbookReact.GrowthBookProvider, {
    growthbook: growthbook
  }, children);
};

exports["default"] = NarvarGrowthBookProvider;
exports.growthbookAttributes = growthbookAttributes;
